"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionMoreActions_1 = require("../../../../../../../../shared/components/table_actions/TableActionMoreActions");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var ToolBarDateRangeFilter_1 = require("../../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var PlayerBonusesList = /** @class */ (function (_super) {
    __extends(PlayerBonusesList, _super);
    function PlayerBonusesList(props) {
        var _this = _super.call(this, props) || this;
        _this.action_more_config = "action:config";
        _this.action_more_inc_bonus_amt = "action:inс-bonus-amt";
        _this.action_more_dec_bonus_amt = "action:dec-bonus-amt";
        _this.action_more_inc_total_bet = "action:inc-total-bet";
        _this.action_more_dec_total_bet = "action:dec-total-bet";
        //  private readonly action_more_transfer_money = "action:transfer-money";
        _this.action_more_set_state_activated = "action:set-state-activated";
        _this.action_more_set_state_completed = "action:set-state-completed";
        _this.action_more_set_state_canceled = "action:set-state-canceled";
        _this.action_more_set_cancelled_bonus_activated = "action:set-cancelled-bonus-activated";
        return _this;
    }
    PlayerBonusesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataBonuses.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat,
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: [],
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            active_bonuses: this.props.isShowOnlyActiveBonuses,
        }, function () {
            _this.loadData(_this.props);
        });
    };
    PlayerBonusesList.prototype.componentWillUnmount = function () {
        this.props.dataBonuses.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PlayerBonusesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
                active_bonuses: nextProps.isShowOnlyActiveBonuses,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    PlayerBonusesList.prototype.loadData = function (Props, onDone) {
        if (this.state.active_bonuses) {
            Props.dataBonuses.LoadDataAvail(Props.player.key, function () {
                if (onDone) {
                    onDone();
                }
            });
        }
        else {
            Props.dataBonuses.LoadData({
                playerId: Props.player.key,
                from_year: this.state.dtFrom.get('year'),
                from_month: this.state.dtFrom.get('month') + 1,
                from_day: this.state.dtFrom.get('date'),
                from_hour: 0,
                from_minute: 0,
                to_year: this.state.dtTo.get('year'),
                to_month: this.state.dtTo.get('month') + 1,
                to_day: this.state.dtTo.get('date'),
                to_hour: 0,
                to_minute: 0,
            }, function () {
                if (onDone) {
                    onDone();
                }
            });
        }
    };
    PlayerBonusesList.prototype.getColumns = function () {
        var _this = this;
        return [
            {
                title: 'Ид',
                dataIndex: this.props.dataBonuses.dk_key,
                key: this.props.dataBonuses.dk_key,
                width: 200,
            }, {
                title: 'Шаблон',
                dataIndex: this.props.dataBonuses.dk_bonus_template_title,
                key: this.props.dataBonuses.dk_bonus_template_title,
                width: 150,
            }, {
                title: 'Тип',
                dataIndex: this.props.dataBonuses.dk_bonus_type_title,
                key: this.props.dataBonuses.dk_bonus_type_title,
                width: 100,
            }, {
                title: 'Статус',
                dataIndex: this.props.dataBonuses.dk_bonus_state_title,
                key: this.props.dataBonuses.dk_bonus_state_title,
                width: 100,
            }, {
                title: 'Триггер',
                dataIndex: this.props.dataBonuses.dk_promo_code_title,
                key: this.props.dataBonuses.dk_promo_code_title,
                width: 150,
                render: function (text, record, idx) {
                    if (record.event_binding_id > 0) {
                        return (React.createElement("div", null,
                            "E:",
                            record.event_binding_title));
                    }
                    if (record.promo_code_id > 0) {
                        return (React.createElement("div", null,
                            "P:",
                            record.promo_code_title));
                    }
                    if (record.usr_admin_id > 0) {
                        return (React.createElement("div", null,
                            "A:",
                            record.usr_admin_login));
                    }
                }
            }, {
                title: 'Истекает',
                dataIndex: this.props.dataBonuses.dk_is_bonus_has_ttl,
                key: this.props.dataBonuses.dk_is_bonus_has_ttl,
                width: 110,
                render: function (text, record, idx) {
                    if (record.is_bonus_has_ttl) {
                        return (React.createElement("div", null, record.date_to_expire.format(_this.state.dtFormat)));
                    }
                    else {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                }
            }, {
                title: 'Вейджер',
                dataIndex: this.props.dataBonuses.dk_wager,
                key: this.props.dataBonuses.dk_wager,
                width: 110,
            }, {
                title: 'Текущий баланс',
                children: [{
                        title: 'Деньги',
                        dataIndex: this.props.dataBonuses.dk_money_balance,
                        key: this.props.dataBonuses.dk_money_balance,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.money_balance.toFixed(2)));
                        }
                    }, {
                        title: 'Бонус',
                        dataIndex: this.props.dataBonuses.dk_bonus_balance,
                        key: this.props.dataBonuses.dk_bonus_balance,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.bonus_balance.toFixed(2)));
                        }
                    }]
            }, {
                title: 'Начальный баланс',
                children: [{
                        title: 'Деньги',
                        dataIndex: this.props.dataBonuses.dk_start_bonus_money_balance,
                        key: this.props.dataBonuses.dk_start_bonus_money_balance,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.start_bonus_money_balance.toFixed(2)));
                        }
                    }, {
                        title: 'Бонус',
                        dataIndex: this.props.dataBonuses.dk_start_bonus_bonus_balance,
                        key: this.props.dataBonuses.dk_start_bonus_bonus_balance,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.start_bonus_bonus_balance.toFixed(2)));
                        }
                    }, {
                        title: 'Игрок',
                        dataIndex: this.props.dataBonuses.dk_start_player_money_balance,
                        key: this.props.dataBonuses.dk_start_player_money_balance,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.start_player_money_balance.toFixed(2)));
                        }
                    }]
            }, {
                title: 'Сумма ставок в отыгрыш',
                children: [{
                        title: 'Совершена',
                        dataIndex: this.props.dataBonuses.dk_totalbet_amount,
                        key: this.props.dataBonuses.dk_totalbet_amount,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.totalbet_amount.toFixed(2)));
                        }
                    }, {
                        title: 'Необходима',
                        dataIndex: this.props.dataBonuses.dk_wagering_amount,
                        key: this.props.dataBonuses.dk_wagering_amount,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, (record.wagering_amount * record.wager).toFixed(2)));
                        }
                    }]
            }, {
                title: 'Фриспины',
                children: [{
                        title: 'Всего',
                        dataIndex: this.props.dataBonuses.dk_freespins_avail,
                        key: this.props.dataBonuses.dk_freespins_avail,
                        width: 90,
                        render: function (text, record, idx) {
                            if (record.is_freespins) {
                                return (React.createElement("div", null, record.freespins_avail));
                            }
                            else {
                                return (React.createElement("div", null,
                                    React.createElement("b", null, "\u043D\u0435\u0442")));
                            }
                        }
                    }, {
                        title: 'Сыграно',
                        dataIndex: this.props.dataBonuses.dk_freespins_played,
                        key: this.props.dataBonuses.dk_freespins_played,
                        width: 90,
                        render: function (text, record, idx) {
                            if (record.is_freespins) {
                                return (React.createElement("div", null, record.freespins_played));
                            }
                            else {
                                return (React.createElement("div", null,
                                    React.createElement("b", null, "\u043D\u0435\u0442")));
                            }
                        }
                    }]
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionMoreActions_1.default, { hint: "\u0415\u0449\u0435", menu: _this.getMoreActionsDropDownMenu(record) }))); },
                width: 80
            }
        ];
    };
    ;
    PlayerBonusesList.prototype.onDeleteClick = function (record) {
        this.props.dataBonuses.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u043E\u043D\u0443\u0441 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    PlayerBonusesList.prototype.onEditClick = function (record) {
        if (this.props.onEditBonusClick) {
            this.props.onEditBonusClick(record);
        }
    };
    PlayerBonusesList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_cancelled_bonus_activated },
                React.createElement(FontAwesome_1.FA, { icon: "check-square", left: true }),
                "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043D\u044B\u0439 \u0431\u043E\u043D\u0443\u0441"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_config },
                React.createElement(FontAwesome_1.FA, { icon: "cog", left: true }),
                "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_inc_bonus_amt },
                React.createElement(FontAwesome_1.FA, { icon: "plus-square", left: true }),
                "\u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u0431\u043E\u043D\u0443\u0441 \u0431\u0430\u043B\u0430\u043D\u0441"),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_dec_bonus_amt },
                React.createElement(FontAwesome_1.FA, { icon: "minus-square", left: true }),
                "\u0423\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u044C \u0431\u043E\u043D\u0443\u0441 \u0431\u0430\u043B\u0430\u043D\u0441"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_inc_total_bet },
                React.createElement(FontAwesome_1.FA, { icon: "plus-square", left: true }),
                "\u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u0441\u0443\u043C\u043C\u0443 \u0441\u0442\u0430\u0432\u043E\u043A"),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_dec_total_bet },
                React.createElement(FontAwesome_1.FA, { icon: "minus-square", left: true }),
                "\u0423\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u044C \u0441\u0443\u043C\u043C\u0443 \u0441\u0442\u0430\u0432\u043E\u043A"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_state_activated },
                React.createElement(FontAwesome_1.FA, { icon: "check-square", left: true }),
                "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C"),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_state_completed },
                React.createElement(FontAwesome_1.FA, { icon: "check-square", left: true }),
                "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u043C"),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_state_canceled },
                React.createElement(FontAwesome_1.FA, { icon: "check-square", left: true }),
                "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043D\u044B\u043C")));
    };
    PlayerBonusesList.prototype.doMorection = function (e, record) {
        var _this = this;
        if (e.key == this.action_more_config) {
            if (this.props.onConfigBonusClick) {
                this.props.onConfigBonusClick(record);
            }
        }
        if (e.key == this.action_more_inc_bonus_amt) {
            this.props.dlgFinance
                .clearFields()
                .SetTitle("Увеличить бонусный баланс бонуса")
                .SetCurrencyTitle("BON")
                .SetTagVisibility(false)
                .SetDescriptionVisibility(false)
                .SetOnYesClick(function (amount, description) {
                _this.props.dataBonuses.DoDepositBonusAmount(record.key, amount, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0411\u043E\u043D\u0443\u0441\u043D\u044B\u0439 \u0431\u0430\u043B\u0430\u043D\u0441 \u0431\u043E\u043D\u0443\u0441\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D \u043D\u0430 \u0441\u0443\u043C\u043C\u0443 ",
                        React.createElement("b", null,
                            "[",
                            amount,
                            "]"),
                        " !"));
                });
            }).Show();
        }
        if (e.key == this.action_more_dec_bonus_amt) {
            this.props.dlgFinance
                .clearFields()
                .SetTitle("Уменьшить бонусный баланс бонуса")
                .SetCurrencyTitle("BON")
                .SetTagVisibility(false)
                .SetDescriptionVisibility(false)
                .SetOnYesClick(function (amount, description) {
                _this.props.dataBonuses.DoWithdrawBonusAmount(record.key, amount, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0421 \u0431\u043E\u043D\u0443\u0441\u043D\u043E\u0433\u043E \u0431\u0430\u043B\u0430\u043D\u0441 \u0431\u043E\u043D\u0443\u0441\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u0441\u043F\u0438\u0441\u0430\u043D\u0430 \u0441\u0443\u043C\u043C\u0430 ",
                        React.createElement("b", null,
                            "[",
                            amount,
                            "]"),
                        " !"));
                });
            }).Show();
        }
        if (e.key == this.action_more_inc_total_bet) {
            this.props.dlgFinance
                .clearFields()
                .SetTitle("Увеличить общую сумму ставок бонуса")
                .SetCurrencyTitle("TB")
                .SetTagVisibility(false)
                .SetDescriptionVisibility(false)
                .SetOnYesClick(function (amount, description) {
                _this.props.dataBonuses.DoDepositTotalBetAmount(record.key, amount, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u041E\u0431\u0449\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0430 \u043D\u0430 \u0441\u0443\u043C\u043C\u0443 ",
                        React.createElement("b", null,
                            "[",
                            amount,
                            "]"),
                        " !"));
                });
            }).Show();
        }
        if (e.key == this.action_more_dec_total_bet) {
            this.props.dlgFinance
                .clearFields()
                .SetTitle("Уменьшить общую сумму ставок бонуса")
                .SetCurrencyTitle("TB")
                .SetTagVisibility(false)
                .SetDescriptionVisibility(false)
                .SetOnYesClick(function (amount, description) {
                _this.props.dataBonuses.DoWithdrawTotalBetAmount(record.key, amount, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0421 \u043E\u0431\u0449\u0435\u0439 \u0441\u0443\u043C\u043C\u044B \u0441\u0442\u0430\u0432\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u0441\u043F\u0438\u0441\u0430\u043D\u0430 \u0441\u0443\u043C\u043C\u0430 ",
                        React.createElement("b", null,
                            "[",
                            amount,
                            "]"),
                        " !"));
                });
            }).Show();
        }
        /*if (e.key == this.action_more_transfer_money) {
            this.props.dlgFinance
                .clearFields()
                .SetTitle("Пополнить бонус со счета игрока")
                .SetCurrencyTitle(this.props.player.app_currency_title)
                .SetDescriptionVisibility(false)
                .SetOnYesClick((amount, description) => {
                    this.props.dataBonuses.DoDepositMoneyAmountFromPlayersBalance(record.key, amount, () => {
                        notificationHelper.ShowTopRightNotification(
                            <div>На баланс бонуса <b>[{record.title}]</b> переведена сумма <b>[{amount}]</b> !</div>
                        );
                    })
                }).Show();
        }*/
        if (e.key == this.action_more_set_state_activated) {
            this.props.dlgYesNo.SetOnNoClick(function () {
                _this.props.dlgYesNo.Close();
            }).SetOnYesClick(function () {
                _this.props.dataBonuses.DoSetStatusActivated(record.key, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0411\u043E\u043D\u0443\u0441 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D !"));
                });
            }).Show();
        }
        if (e.key == this.action_more_set_state_completed) {
            this.props.dlgYesNo.SetOnNoClick(function () {
                _this.props.dlgYesNo.Close();
            }).SetOnYesClick(function () {
                _this.props.dataBonuses.DoSetStatusCompleted(record.key, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0411\u043E\u043D\u0443\u0441 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D !"));
                });
            }).Show();
        }
        if (e.key == this.action_more_set_state_canceled) {
            this.props.dlgYesNo.SetOnNoClick(function () {
                _this.props.dlgYesNo.Close();
            }).SetOnYesClick(function () {
                _this.props.dataBonuses.DoSetStatusCancelled(record.key, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0411\u043E\u043D\u0443\u0441 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u043E\u0442\u043C\u0435\u043D\u0435\u043D !"));
                });
            }).Show();
        }
        if (e.key == this.action_more_set_cancelled_bonus_activated) {
            this.props.dlgYesNo.SetTitle("Вопрос");
            this.props.dlgYesNo.SetMessage("Восстановить отмененный бонус?");
            this.props.dlgYesNo.SetOnNoClick(function () {
                _this.props.dlgYesNo.Close();
            }).SetOnYesClick(function () {
                _this.props.dataBonuses.DoSetStatusCancelledToActive(record.key, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0411\u043E\u043D\u0443\u0441 ",
                        React.createElement("b", null,
                            "[",
                            record.title,
                            "]"),
                        " \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D !"));
                });
            }).Show();
        }
    };
    PlayerBonusesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PlayerBonusesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "create") {
            if (this.props.onNewBonusClick) {
                this.props.onNewBonusClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PlayerBonusesList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    PlayerBonusesList.prototype.onCheckBoxChecked = function (checked) {
        if (this.props.onShowOnlyActiveBonusesClick) {
            this.props.onShowOnlyActiveBonusesClick(checked);
        }
    };
    PlayerBonusesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Пополнить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, "\u0422\u043E\u043B\u044C\u043A\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435"),
                React.createElement(antd_1.Switch, { checked: this.state.active_bonuses, onChange: this.onCheckBoxChecked.bind(this) }),
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this), disabled: this.state.active_bonuses })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435:"),
                            " [",
                            record.title,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.state.dtFormat),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D \u043A\u043E\u043D\u0444\u0438\u0433:"),
                            " [",
                            record.date_cfg_changed.format(_this.state.dtFormat),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D:"),
                            " [",
                            record.date_activated.format(_this.state.dtFormat),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A:"),
                            " [",
                            _this.props.player.login,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"),
                            " [",
                            record.description,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0431\u043E\u043D\u0443\u0441\u0430:"),
                            " [",
                            ((record.totalbet_amount) / (record.wagering_amount * record.wager) * 100).toFixed(2),
                            "%]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0417\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F, \u043A\u043E\u043B-\u0432\u043E:"),
                            " [",
                            record.after_complete_credits_count,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0417\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F, \u0441\u0443\u043C\u043C\u0430:"),
                            " [",
                            record.after_completed_credit_amount,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0417\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438, \u0441\u0443\u043C\u043C\u0430:"),
                            " [",
                            record.complete_amount,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F:"),
                            " [",
                            record.completition_max_amount,
                            "]")));
                }, scroll: { x: true } })));
    };
    return PlayerBonusesList;
}(React.Component));
exports.default = PlayerBonusesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/bonuses/PlayerBonusesList.tsx
// module id = 1930
// module chunks = 0